import "./search-bar.scss";

import React, { useState, useEffect } from "react";
import { Link, navigate } from "gatsby";
import classNames from "classnames";

const SearchBar = ({ opened, onCloseClick, data }) => {
  const options = data.nodes[0].acfOptionsOpcje.optionsPage;
  const [searchValue, setSearchValue] = useState("");
  const [searchedStrings, setSearchedStrings] = useState([]);
  const fetchStrings = () => {
    setSearchedStrings(
      JSON.parse(localStorage.getItem("searchedStrings")) || []
    );
  };
  const handleSearch = () => {
    navigate(`/wyszukiwarka/?searchString=${searchValue}`);
    if (
      searchedStrings?.includes(searchValue) === false &&
      searchValue !== ""
    ) {
      setSearchedStrings([...searchedStrings, searchValue]);
      localStorage.setItem("searchedStrings", JSON.stringify(searchedStrings));
    }
  };
  useEffect(() => {
    fetchStrings();
  }, []);

  useEffect(() => {
    localStorage.setItem("searchedStrings", JSON.stringify(searchedStrings));
  }, [searchedStrings]);
  return (
    <div
      className={classNames("search-container", {
        [`search-container search-container--active`]: opened === true,
      })}
    >
      <button
        type="button"
        className="search-container__close-btn"
        onClick={onCloseClick}
      >
        &#10005;
      </button>
      <div className="search-container__form">
        <div className="search-container__input-wrapper">
          <input
            type="search"
            className="search-container__input"
            placeholder="Przeszukaj Elcamp RV"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(e);
              }
            }}
          />
          <div className="search-container__stored-strings-container">
            <div className="search-container__stored-strings-title">
              Ostatnie wyszukiwania:
            </div>
            {searchedStrings?.map((string, index) => {
              return (
                <Link
                  key={index}
                  className="search-container__single-stored-string"
                  to={`/wyszukiwarka/?searchString=${string}`}
                >
                  {string}
                </Link>
              );
            })}
          </div>
        </div>
        <button
          type="button"
          className="search-container__search-btn btn"
          id="search-submit"
          onClick={(e) => handleSearch()}
        >
          Szukaj
        </button>
      </div>
      <div className="bottom-content">
        <div>
          <div className="bottom-content__fast-access-label">
            Szybki dostęp - popularne wyszukiwania
          </div>
          <div className="bottom-content__menu-container">
            <ul className="bottom-content__menu">
              <li className="bottom-content__menu-item">
                <Link to="/kontakt" className="bottom-content__menu-link">
                  Kontakt
                </Link>
              </li>
              <li className="bottom-content__menu-item">
                <Link
                  to="/nowe-kampery-i-nowe-przyczepy-campingowe/"
                  className="bottom-content__menu-link"
                >
                  Kampery nowe
                </Link>
              </li>
              <li className="bottom-content__menu-item">
                <a
                  rel="noreferrer nofollow"
                  target="_blank"
                  href="https://www.facebook.com/GrupaElcamp/"
                  className="bottom-content__menu-link"
                >
                  Facebook
                </a>
              </li>
              <li className="bottom-content__menu-item">
                <a
                  rel="noreferrer nofollow"
                  target="_blank"
                  href="https://www.instagram.com/grupa_elcamp/"
                  className="bottom-content__menu-link"
                >
                  Instagram
                </a>
              </li>
              <li className="bottom-content__menu-item">
                <a
                  rel="noreferrer nofollow"
                  target="_blank"
                  href="https://www.youtube.com/channel/UC5xNMylmVKGlcotQYHxAmfw"
                  className="bottom-content__menu-link"
                >
                  Zawieszenia
                </a>
              </li>
            </ul>
            <ul className="bottom-content__menu">
              <li className="bottom-content__menu-item">
                <Link to="/serwis" className="bottom-content__menu-link">
                  Serwis
                </Link>
              </li>
              <li className="bottom-content__menu-item">
                <Link
                  to="/serwis#serwis-8"
                  className="bottom-content__menu-link"
                >
                  Części
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          className="bottom-content__promoted-product"
          style={{
            backgroundImage: `url(${options?.promotedProductImage?.sourceUrl})`,
          }}
        >
          <div>
            <div className="bottom-content__product-label">
              Polecany produkt
            </div>
            <div className="bottom-content__product-title">
              {options.promotedProductTitle}
            </div>
            <a
              href={options.promotedProductLink}
              target="_blank"
              rel="noreferrer"
              className="bottom-content__shop-btn"
              style={{
                backgroundColor: options.promotedButtonColor,
              }}
            >
              {options.promotedButtonName}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
